
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/elementor",
      function () {
        return require("private-next-pages/[locale]/elementor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/elementor"])
      });
    }
  